import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0b5b7ed6")

_pushScopeId("data-v-0b5b7ed6")
const _hoisted_1 = { class: "config" }
const _hoisted_2 = { class: "core" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "downBtn" }, [
  /*#__PURE__*/_createVNode("div", { class: "step_title" }, "安装工具")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "安装广告看板Chrome浏览器插件，将店铺与Facebook广告平台建立连接", -1)
const _hoisted_5 = { style: {"margin-top":"16px"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 下载插件 ")
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "step_title" }, "关联账户", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, "关联浏览器插件与店铺", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "btn_text" }, "网关地址", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "btn_text" }, "秘钥", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "step_title" }, "添加UTM参数", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { style: {"margin-bottom":"16px"} }, "将utm参数复制在您想要投放的网站URL的结尾", -1)
const _hoisted_13 = { class: "btn_copy" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "step_title" }, "查看广告数据", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { style: {"line-height":"normal"} }, " 定制栏目，展示广告系列编号，广告组编号，广告编号，成效，花费金额，广告花费回报（ROAS）-购物等六个指标，全面衡量广告成效 ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_step = _resolveComponent("el-step")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_steps = _resolveComponent("el-steps")
  const _component_el_form = _resolveComponent("el-form")
  const _component_FormSkeleton = _resolveComponent("FormSkeleton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("header", null, [
      _createVNode(_component_PageHeader, { title: "广告看板" })
    ]),
    _createVNode("main", null, [
      _createVNode(_component_FormSkeleton, { loading: _ctx.loading }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_el_form, {
              model: _ctx.formData,
              "label-width": "120px",
              size: "small",
              "label-position": "top"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_steps, { direction: "vertical" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_step, null, {
                      title: _withId(() => [
                        _hoisted_3
                      ]),
                      description: _withId(() => [
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _hoisted_4,
                            _createVNode("div", _hoisted_5, [
                              _createVNode("a", {
                                href: `https://24073-fbadsboard.cn01-apps.ymcart.com/res/manage/default/tpl/fbadsboard/statics/chrome-fbadsboard-ext.zip?${new Date().getTime()}`
                              }, [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  size: "mini",
                                  style: {"font-size":"14px"}
                                }, {
                                  default: _withId(() => [
                                    _hoisted_6
                                  ]),
                                  _: 1
                                })
                              ], 8, ["href"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_step, null, {
                      title: _withId(() => [
                        _hoisted_7
                      ]),
                      description: _withId(() => [
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _hoisted_8,
                            _hoisted_9,
                            _createVNode(_component_el_input, {
                              readonly: "",
                              modelValue: _ctx.formData.gate,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.gate = $event)),
                              placeholder: "Please input"
                            }, {
                              append: _withId(() => [
                                _createVNode(_component_el_button, {
                                  icon: "shopyy-iconfont icon-fuzhi",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyText(_ctx.formData.gate)))
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _hoisted_10,
                            _createVNode(_component_el_input, {
                              readonly: "",
                              modelValue: _ctx.formData.secret,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.secret = $event)),
                              placeholder: "Please input"
                            }, {
                              append: _withId(() => [
                                _createVNode(_component_el_button, {
                                  icon: "shopyy-iconfont icon-fuzhi",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyText(_ctx.formData.secret)))
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_step, null, {
                      title: _withId(() => [
                        _hoisted_11
                      ]),
                      description: _withId(() => [
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _hoisted_12,
                            _createVNode("div", _hoisted_13, [
                              _createVNode(_component_el_input, {
                                readonly: "",
                                modelValue: _ctx.formData.shop_domain,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.shop_domain = $event)),
                                placeholder: "Please input"
                              }, {
                                append: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    icon: "shopyy-iconfont icon-fuzhi",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.copyText(_ctx.formData.shop_domain)))
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_step, null, {
                      title: _withId(() => [
                        _hoisted_14
                      ]),
                      description: _withId(() => [
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ]))
})